module.exports = __webpack_public_path__ + "24e004ab/img/SOURCERY_poweredby_web.9819842b.png";